import styled from '@emotion/styled';
import { Box, Tab, Tabs, Theme } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledTab = styled(Tab)`
  min-height: 24px;

  & h6 {
    font-size: 14px;
    line-height: 1rem;
    text-transform: none;
    margin-right: 10px;
  }
`;

export const StyledTabs = styled(Tabs)`
  & .MuiTabs-scroller {
    overflow-x: auto !important;
    overflow-y: hidden;
    height: 80px;
  }
  & .MuiTabs-list {
    position: absolute;
  }
  & .MuiTabs-indicator {
    background-color: ${colors.gray900};
    height: 4px;
  }
`;

export const NoResultWrapper = styled(Box)`
  padding: 20px;
  border: 1px solid ${colors.gray200};
  background-color: ${colors.gray100};

  ${({ theme }) => `
    ${(theme as Theme).breakpoints.up('lg')} {
      margin-top: -50px;
      };
      `};
`;
